import ComText from '../components/base/text/com-index'
import ComMainTitle from '../components/base/main-title/com-index'
import ComSubTitle from '../components/base/sub-title/com-index'
import ComBlockQuote from '../components/base/blockquote/com-index'
import ComOrderLine from '../components/base/order-line/com-index'
import ComUnorderLine from '../components/base/unorder-line/com-index'
import ComLine from '../components/base/line/com-index'
import ComImg from '../components/base/img/com-index'
import ComImgDesc from '../components/base/img-desc/com-index'
import ComIframe from '../components/base/iframe/com-index'
import ComOriginSource from '../components/base/origin-source/com-index'
import ComNewsSource from '../components/base/news-source/com-index'
import ComCardPlaceholder from '../components/cards/card-placeholder/com-index'
import { GameCards } from '../components/cards/game-card/com-index'
import { SkuCards } from '../components/cards/sku-card/com-index'
import { WikiCards } from '../components/cards/wiki-card/com-index'
import { AlbumCards } from '../components/cards/album-card/com-index'
import { LeagueCards } from '../components/cards/league-card/com-index'
import { MatchCards } from '../components/cards/match-card/com-index'
import { AwardTableCards } from '../components/cards/award-table-card/com-index'
import { ChatRoomCards } from '../components/cards/chatroom-card/com-index'
import { Dota2MatchRecordCards } from '../components/cards/dota2-match-record-card/com-index'
import { LOLMatchRecordCards } from '../components/cards/lol-match-record-card/com-index'
import HeyboxIcon from '_lib/plugin/heybox-icon'

// Vue实例
let _vue

export function loadCards (article) {
  return {
    game: new GameCards(article),
    wiki: new WikiCards(article),
    sku: new SkuCards(article),
    album: new AlbumCards(article),
    league: new LeagueCards(article),
    match: new MatchCards(article),
    award_table: new AwardTableCards(article),
    chatroom: new ChatRoomCards(article),
    dota2_match_record: new Dota2MatchRecordCards(article),
    lol_match_record: new LOLMatchRecordCards(article)
  }
}

export function dynamicImportCpt (cpt_loader) {
  cpt_loader(_vue)
}

export const articlePlugin = {
  install (Vue) {
    _vue = Vue
    Vue
      .use(HeyboxIcon)
      .use(ComText)
      .use(ComMainTitle)
      .use(ComSubTitle)
      .use(ComBlockQuote)
      .use(ComOrderLine)
      .use(ComUnorderLine)
      .use(ComLine)
      .use(ComImg)
      .use(ComImgDesc)
      .use(ComIframe)
      .use(ComOriginSource)
      .use(ComNewsSource)
      .use(ComCardPlaceholder)
      // .use(ComGameCard)
      // .use(ComSkuCard)
      // .use(ComWikiCard)
      // .use(ComAlbumCard)
      // .use(ComLeagueCard)
      // .use(ComMatchCard)
      // .use(ComDota2MatchRecordCard)
      // .use(ComLOLMatchRecordCard)
  }
}